import { environment } from '../environments/environment';
const ɵ0 = environment, ɵ1 = window.localStorage;
export class CoreModule {
}
export { ɵ0, ɵ1 };
